import React from 'react';

export const TARIFF_SERVICES = [
  {
    name: 'Демонтаж старых напольных покрытий',
    type: 'REMONT',
    cosmetic: true,
    capital: true,
    design: true,
    states: [true, true, true],
  },
  {
    name: <>Очистка стен и потолков от старых покрытий</>,
    type: 'REMONT',
    cosmetic: true,
    capital: true,
    design: true,
    states: [true, true, true],
  },
  {
    name: 'Замена электропроводки',
    type: 'REMONT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },
  {
    name: 'Перенос электроточек',
    type: 'REMONT',
    cosmetic: false,
    capital: false,
    design: true,
    states: [false, false, true],
  },
  {
    name: 'Замена сантехнических коммуникаций',
    type: 'REMONT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },
  {
    name: 'Перенос сантехнических коммуникаций',
    type: 'REMONT',
    cosmetic: false,
    capital: false,
    design: true,
    states: [false, false, true],
  },

  {
    name: (
      <>
        Частичное выравнивание
        <br /> поверхностей, шпатлевание,
        <br />
        грунтовка, бетоноконтакт
      </>
    ),
    type: 'REMONT',
    cosmetic: true,
    capital: false,
    design: false,
    states: [true, false, false],
  },

  {
    name: 'Выравнивание потолков',
    type: 'REMONT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },

  {
    name: 'Выравнивание полов',
    type: 'REMONT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },

  {
    name: 'Выравнивание стен',
    type: 'REMONT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },

  {
    name: 'Гидро- и шумоизоляция',
    type: 'REMONT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },

  {
    name: 'Шпатлёвка потолков и стен под покраску',
    type: 'REMONT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },

  {
    name: 'Расшивка и затирка швов плитки',
    type: 'REMONT',
    cosmetic: true,
    capital: true,
    design: true,
    states: [true, true, true],
  },

  {
    name: 'Укладка плитки на пол и на стены',
    type: 'REMONT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },

  {
    name: 'Покраска потолков и стен',
    type: 'REMONT',
    cosmetic: true,
    capital: true,
    design: true,
    states: [true, true, true],
  },

  {
    name: 'Монтаж новых напольных покрытий',
    type: 'REMONT',
    cosmetic: true,
    capital: true,
    design: true,
    states: [true, true, true],
  },

  {
    name: 'Установка новых дверей',
    type: 'REMONT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },

  {
    name: 'Возведение стен и перегородок',
    type: 'REMONT',
    cosmetic: false,
    capital: false,
    design: true,
    states: [false, false, true],
  },

  {
    name: 'Монтаж теплого пола',
    type: 'REMONT',
    cosmetic: false,
    capital: false,
    design: true,
    states: [false, false, true],
  },

  {
    name: 'Развёртка — план для чистовых работ',
    type: 'PROJECT',
    cosmetic: true,
    capital: true,
    design: true,
    states: [true, true, true],
  },

  {
    name: 'Сантехнический план',
    type: 'PROJECT',
    cosmetic: false,
    capital: true,
    design: true,
    states: [false, true, true],
  },

  {
    name: 'План электрики',
    type: 'PROJECT',
    cosmetic: false,
    capital: false,
    design: true,
    states: [false, false, true],
  },

  {
    name: 'Монтажный чертёж',
    type: 'PROJECT',
    cosmetic: false,
    capital: false,
    design: true,
    states: [false, false, true],
  },
];
